import * as React from 'react';
import { Scroller } from '@cian/slider';

import { OnboardingSlideDesktop } from '../../../../components/OnboardingSlideDesktop';
import { OnboardingSlideMobile } from '../../../../components/OnboardingSlideMobile';
import { IOnboardingProps } from '../../types';

export const OnboardingSlidesContainer: React.FC<Omit<IOnboardingProps, 'onFinishClick'>> = ({ slides, isMobile }) => {
  const slideNodes = React.useMemo(() => {
    return slides.map(({ title, text, src }) =>
      isMobile ? (
        <OnboardingSlideMobile key={title} src={src} title={title} text={text} />
      ) : (
        <OnboardingSlideDesktop key={title} src={src} title={title} text={text} />
      ),
    );
  }, [isMobile, slides]);

  return <Scroller>{slideNodes}</Scroller>;
};
